import React, { useEffect, useRef } from "react";

// Decorative floating floral SVGs that drift & react to scroll (parallax).
const FLORALS = [
  { top: "8%", left: "4%", size: 90, speed: 0.15, delay: 0, rot: -12 },
  { top: "22%", right: "3%", size: 120, speed: 0.22, delay: 1200, rot: 18 },
  { top: "48%", left: "2%", size: 80, speed: 0.1, delay: 800, rot: 8 },
  { top: "70%", right: "4%", size: 110, speed: 0.18, delay: 400, rot: -22 },
  { top: "88%", left: "6%", size: 95, speed: 0.12, delay: 1600, rot: 12 },
];

const FloralSVG = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#b08c48" strokeWidth="1.1" fill="none" opacity="0.55">
      <path d="M50 90 C 50 70, 40 55, 30 45" />
      <path d="M50 90 C 50 70, 60 55, 70 45" />
      <path d="M50 60 C 50 50, 45 40, 50 20" />
      <ellipse cx="30" cy="45" rx="7" ry="3" transform="rotate(-30 30 45)" />
      <ellipse cx="70" cy="45" rx="7" ry="3" transform="rotate(30 70 45)" />
      <circle cx="50" cy="18" r="5" />
      <circle cx="50" cy="18" r="2" fill="#b08c48" />
      <circle cx="42" cy="30" r="3" />
      <circle cx="58" cy="30" r="3" />
      <circle cx="42" cy="30" r="1" fill="#b08c48" />
      <circle cx="58" cy="30" r="1" fill="#b08c48" />
    </g>
  </svg>
);

const FloatingFlorals = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const onScroll = () => {
      const root = rootRef.current;
      if (!root) return;
      const y = window.scrollY;
      const nodes = root.querySelectorAll(".floral");
      nodes.forEach((n) => {
        const speed = parseFloat(n.dataset.speed || "0.15");
        const rot = parseFloat(n.dataset.rot || "0");
        n.style.transform = `translate3d(0, ${y * speed * -1}px, 0) rotate(${rot + y * 0.02}deg)`;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="floral-layer" ref={rootRef} aria-hidden="true">
      {FLORALS.map((f, i) => (
        <div
          key={i}
          className="floral"
          data-speed={f.speed}
          data-rot={f.rot}
          style={{
            top: f.top,
            left: f.left,
            right: f.right,
            width: f.size,
            height: f.size,
            animationDelay: `${f.delay}ms`,
          }}
        >
          <FloralSVG size={f.size} />
        </div>
      ))}
    </div>
  );
};

export default FloatingFlorals;
